<template>
  <div>
    <div
      v-if="readyImport"
      class="card card-large-icons"
    >
      <div class="card-icon bg-warning text-white">
        <i class="fas fa-check" />
      </div>
      <div class="card-body">
        <h4>Sinkronisasi Siap Dilakukan</h4>
        <p>{{ readyImport.keterangan }}</p>
        <button
          class="btn btn-primary mx-1"
          :data-id="readyImport.id_riwayat_sync_penduduk"
          @click="$emit('detailRiwayat', readyImport)"
        >
          <i class="fa fa-eye mr-2" /> Detail
        </button>
        <button
          class="btn btn-info mx-1"
          :data-id="readyImport.id_riwayat_sync_penduduk"
          @click="$emit('sinkronisasi', readyImport)"
        >
          <i class="fa fa-sync mr-2" /> Sinkronkan
        </button>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h4>Riwayat Sinkronisasi</h4>
        <div class="card-header-action">
          <!-- <button
                        class="btn btn-success mb-3"
                        @click="$emit('setAksiSync', 1)">
                        <i class="fa fa-file mr-2"></i>
                        Upload File Penduduk
                    </button> -->
          <button
            class="btn btn-primary mb-3"
            @click="$bvModal.show('modal-help-sinkronisasi')"
          >
            <i class="fa fa-info-circle mr-2" />
            Panduan
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="text-right" />
                
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>Tanggal</th>
                <th>User</th>
                <th>Keterangan</th>
                <th>Status</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody v-if="!loadingRiwayat && riwayatImport.length > 0">
              <tr
                v-for="r in riwayatImport"
                :key="r.id_riwayat_sync_penduduk"
              >
                <td>{{ new Date(r.tanggal_sync).toLocaleDateString('id-ID', {year: 'numeric', month: 'short', day: 'numeric'}) }} {{ new Date(r.tanggal_sync).toLocaleTimeString('it-IT') }}</td>
                <td>{{ r.user.penduduk.nama_lengkap }}</td>
                <td>{{ r.keterangan }}</td>
                <td>
                  <span
                    v-if="r.status === 0"
                    class="badge badge-warning"
                  >
                    <i class="fa fa-info-circle mr-2" />Belum disinkronkan
                  </span>
                  <span
                    v-if="r.status === 1"
                    class="badge badge-success"
                  >
                    <i class="fa fa-check-circle mr-2" />Berhasil
                  </span>
                  <span
                    v-if="r.status === 2"
                    class="badge badge-info"
                  >
                    <i class="fa fa-sync fa-spin mr-2" />Sedang Proses
                  </span>
                </td>
                <td>
                  <button
                    class="btn btn-primary btn-sm btn-detail-riwayat"
                    :data-id="r.id_riwayat_sync_penduduk"
                    @click="$emit('detailRiwayat', r)"
                  >
                    <i class="fa fa-eye mr-2" />Detail
                  </button>
                  <button
                    v-if="r.status === 0"
                    class="btn btn-info btn-sm btn-sinkronkan"
                    :data-id="r.id_riwayat_sync_penduduk"
                    @click="$emit('sinkronisasi', r)"
                  >
                    <i class="fa fa-sync mr-2" />Sinkronkan
                  </button>
                </td>
              </tr>
            </tbody>
            <tbody v-if="!loadingRiwayat && riwayatImport.length === 0">
              <tr>
                <td
                  colspan="5"
                  class="text-center"
                >
                  Belum ada data
                </td>
              </tr>
            </tbody>
            <tbody v-if="loadingRiwayat">
              <tr>
                <td colspan="5">
                  <div class="spinner-container">
                    <div class="spinner" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <SinkronisasiModalHelp />
  </div>
</template>

<script>
import SinkronisasiModalHelp from './SinkronisasiModalHelp.vue'
export default {
    data() {
        return {

        }
    },
    components: {
        SinkronisasiModalHelp
    },
    props: {
      readyImport: {
        type: Object,
        default: () => null
      },
      riwayatImport: {
        type: Array,
        default: () => null
      },
      loadingRiwayat: {
        type: Boolean,
        default: () => null
      }
    }
}
</script>